// import React, { useEffect, useState } from 'react';
// import { useParams, Link } from 'react-router-dom';
// import axios from 'axios';
// import ReactMarkdown from 'react-markdown';
// import './JobDetailsPage.css';
// import Footer from './Footer';
// import Header from './Header';

// function JobDetailsPage() {
//   const { id } = useParams();
//   const [job, setJob] = useState(null);
//   const [error, setError] = useState('');

//   useEffect(() => {
//     async function fetchJob() {
//       try {
//         const response = await axios.get(`http://localhost:5000/jobs/${id}`);
//         setJob(response.data);
//       } catch (err) {
//         setError(err.response?.data || 'Error fetching job details');
//       }
//     }
//     fetchJob();
//   }, [id]);

//   if (error) {
//     return <div style={{ color: 'red' }}>{error}</div>;
//   }
//   if (!job) {
//     return <div>Loading job details...</div>;
//   }

//   // Destructure the job object for cleaner JSX,
//   // including new fields: startDate, freeDay, postedAt.
//   const {
//     job_name,
//     job_description,
//     job_location,
//     salary,
//     job_type,
//     job_link,
//     photo,
//     startDate,
//     freeDay,
//     postedAt,
//     number_of_working_hours, // ✅ NEW
//     accomodation,             // ✅ NEW
//     food                      // ✅ NEW
//   } = job;


//   return (
//     <>
//       <Header />

//       {/* Cover Photo */}
//       {photo && (
//         <div className="job-cover-photo">
//           <img src={photo} alt={job_name} />
//         </div>
//       )}
//       <div className="job-details-bg-wrapper ">
//         {/* Main Job Details Container */}
//         <div className="job-details-container">
//           <main className="job-details-page">
//             {/* Left Section - Job Description */}
//             <section className="job-details-content">
//               <span className="job-status">Stalni Posao</span>
//               <h1 className="job-title">{job_name}</h1>
//               <div className="job-description">
//                 <ReactMarkdown>{job_description}</ReactMarkdown>
//               </div>
//             </section>

//             {/* Right Section - Job Information */}
//             <aside className="job-sidebar">
//               <div className="job-sidebar-content">
//                 <h2 className="sidebar-title">Sezonski Poslovi Star</h2>
//                 <div className="job-info">
//                   <p><strong>💶 Salary:</strong> €{salary} / month</p>
//                   <p>
//                     <strong>📅 Posted At:</strong>{' '}
//                     {postedAt ? new Date(postedAt).toLocaleDateString() : '-'}
//                   </p>
//                   <p>
//                     <strong>🗓 Start Date:</strong>{' '}
//                     {startDate ? new Date(startDate).toLocaleDateString() : '-'}
//                   </p>
//                   <p><strong>📍 Location:</strong> {job_location}</p>
//                   <p>
//                     <strong>🆓 Free Day:</strong>{' '}
//                     {freeDay ? 'Yes' : 'No'}
//                   </p>
//                   <p>
//                     <strong>📌 Type:</strong> {job_type}
//                   </p>
//                   <p><strong>&nbsp;⏱ Working Hours:</strong> {number_of_working_hours} h/day</p>
//                   <p><strong>🏠 Accommodation:</strong> {accomodation}</p>
//                   <p><strong>&nbsp;🍽 Food Provided:</strong> {food}</p>
//                 </div>
//                 <p>
//                   <strong>🔗 Apply below:</strong>{' '}
//                   <a href={job_link} target="_blank" rel="noopener noreferrer">
//                     {job_link}
//                   </a>
//                 </p>
//                 <Link to="/fastApplication">
//                   <button className="apply-button">APLICIRAJ</button>
//                 </Link>
//               </div>
//             </aside>
//           </main>
//         </div>
//       </div>
//       <Footer />
//     </>
//   );
// }

// export default JobDetailsPage;





import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';
import './JobDetailsPage.css';
import Footer from './Footer';
import Header from './Header';
import { Helmet } from "react-helmet-async";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;



function JobDetailsPage() {
  const { id } = useParams();
  const [job, setJob] = useState(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    let alive = true;                        // cleanup guard
    const MIN_LOAD_MS = 500;                // 2.2s (tweak 2000–3000 as you like)

    const wait = (ms) => new Promise((r) => setTimeout(r, ms));

    (async () => {
      const start = Date.now();
      try {
        const { data } = await axios.get(`${API_BASE_URL}/jobs/${id}`);
        const elapsed = Date.now() - start;
        if (elapsed < MIN_LOAD_MS) await wait(MIN_LOAD_MS - elapsed); // enforce minimum
        if (alive) setJob(data);
      } catch (err) {
        const elapsed = Date.now() - start;
        if (elapsed < MIN_LOAD_MS) await wait(MIN_LOAD_MS - elapsed); // enforce minimum
        if (alive) setError(err.response?.data || 'Error fetching job details');
      }
    })();

    return () => { alive = false; };
  }, [id]);


  if (error) return <div style={{ color: 'red' }}>{error}</div>;
  if (!job) {
  return (
    <>
      <Header />

      <div className="job-details-bg-wrapper">
        <div className="loading-page" role="status" aria-live="polite">
          <div className="spinner" aria-hidden="true" />
          <h2 className="loading-text">
            Učitavanje detalja posla
            <span className="dots">
              <span>.</span><span>.</span><span>.</span>
            </span>
          </h2>
        </div>
      </div>

      <Footer />
    </>
  );
}


  const {
    job_name,
    job_description,
    job_location,
    salary,
    job_type,
    job_link,
    startDate,
    freeDay,
    postedAt,
    number_of_working_hours,
    accomodation,
    food
  } = job;

  const typeClass =
    job_type === 'Stalni' ? 'job-card-type-stalni' : 'job-card-type-sezonski';

  return (
    <>
      <Helmet>
      <title>{job ? `${job.job_name} | Sezonski Poslovi Star` : "Detalji Posla | Sezonski Poslovi Star"}</title>
      <meta
        name="description"
        content={job ? `Detalji o poslu ${job.job_name} u ${job.job_location}. Plata: €${job.salary}/mo.` : "Pogledajte detalje o poslu."}
      />
      <meta
        name="keywords"
        content="posao, oglasi, karijera, zapošljavanje, detalji posla"
      />
      <meta property="og:title" content={job ? job.job_name : "Detalji posla"} />
      <meta
        property="og:description"
        content="Detaljan opis posla, uslovi i beneficije. Pogledajte ponudu sada."
      />
      <meta property="og:image" content="/images/seo-banner.jpg" />
    </Helmet>

      <Header />

      {/* Background wrapper keeps the brand image behind everything */}
      <div className="job-details-bg-wrapper">
        {/* Optional cover photo */}
        {/* {photo && (
          <figure className="job-cover-photo">
            <img src={photo} alt={job_name} />
          </figure>
        )} */}

        {/* Main container */}
        <div className="job-details-container">
          {/* Top header row: title, location, type pill */}
          <header className="job-header">
            <div className="job-header-left">
              <h1 className="job-title">{job_name}</h1>
              <div className="job-sub">
                <span className="job-loc">📍 {job_location}</span>
                <span className={`job-type-pill ${typeClass}`}>{job_type}</span>
              </div>
            </div>
          </header>


          {/* Meta grid (consistent with other pages) */}
          <section className="job-meta-grid">
            <div className="meta-item">
              <div className="meta-label">Plata</div>
              <div className="meta-val">💶 €{salary}/mj</div>
            </div>
            <div className="meta-item">
              <div className="meta-label">Objavljen</div>
              <div className="meta-val">
                📅 {postedAt ? new Date(postedAt).toLocaleDateString() : '-'}
              </div>
            </div>
            <div className="meta-item">
              <div className="meta-label">Početak rada</div>
              <div className="meta-val">
                🗓 {startDate ? new Date(startDate).toLocaleDateString() : '-'}
              </div>
            </div>
            <div className="meta-item">
              <div className="meta-label">Slobodan dan</div>
              <div className="meta-val">{freeDay ? '✅ Da' : '❌ Ne'}</div>
            </div>
          </section>

          {/* Two-column content area (grid) */}
          <main className="job-details-page">
            <section className="job-details-content">
              <div className="markdown job-description">
                <ReactMarkdown>{job_description}</ReactMarkdown>
              </div>
            </section>

            <aside className="job-sidebar">
              <div className="job-sidebar-content">
                <h2 className="sidebar-title">Sezonski Poslovi Star</h2>
                <div className="job-info">
                  <p><strong>📍 Lokacija:</strong> {job_location}</p>
                  <p><strong>⏱ Broj radnih sati:</strong> {number_of_working_hours}h/dnevno</p>
                  <p><strong>🏠 Smještaj:</strong> {accomodation === 'DA' ? 'Da' : 'Ne'}</p>
                  <p><strong>🍽 Broj obroka:</strong> {food}</p>
                  <p>
                    <a href={job_link} target="_blank" rel="noopener noreferrer">
                      {job_link}
                    </a>
                  </p>
                </div>

                {/* <Link to="/fastApplication">
                  <button className="apply-button">APLICIRAJ ZA POSAO</button>
                </Link> */}
                <button
                  className="apply-button"
                  onClick={() =>
                    navigate('/fastApplication', {
                      state: { jobTitle: job_name }
                    })
                  }
                >
                  APLICIRAJ ZA POSAO
                </button>

              </div>
            </aside>
          </main>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default JobDetailsPage;
